define('app/views/support_24_7_view',['app/setup'], function(takhfifan) {

    takhfifan.Support247View = takhfifan.BaseView.extend({

        events: {
            'click .24-7-close-btn': 'close'
        },

        initialize: function() {
            this.cookie = "support_24_7_closed";
            this.render();
        },

        render: function() {
            if ($.cookie(this.cookie) !== 'true') {
                this.$el.show();
            }
        },

        close: function(e) {
            e.preventDefault();
            this.$el.slideUp('slow');
            this.setCookie({ expires: 30, name: this.cookie });
            return false;
        }
    });
});

